import { sdkLogger } from '../../logger/logger';
import type { SdkLoggableError } from '../../types/shared';
import type { SurveyValidationFailure } from '../utils/validatePagesByIndices';

export function logValidationPassedSubmit(): void {
  sdkLogger.success('Survey validation passed on submit');
}

export function logValidationErrorSubmit(validation: SurveyValidationFailure): void {
  sdkLogger.warn('Full survey validation failed on submit', { validation });
}

export function logValidationFailedSubmit(err: SdkLoggableError): void {
  sdkLogger.error('Failed to run survey validation on submit', { err });
}

export function logValidationErrorPage(errors: Record<string, string>): void {
  sdkLogger.warn('Page validation failed', { errors });
}
